//Based on http://imakewebthings.github.com/jquery-waypoints/#documentation
// and http://imakewebthings.github.com/jquery-waypoints/sticky-elements/

jQuery(function($) {

    // Notify when a waypoint is reach to change the highlighted tab
    $('body').delegate('#content-box > section', 'waypoint.reached', function(event, direction) {
        var $active = $(this);

        if (direction === "up") {
            $active = $active.prev();
        }
        if (!$active.length) $active = $active.end();

        $('.section-active').removeClass('section-active');
        $active.addClass('section-active');

        $('.link-active').removeClass('link-active');
        $('a[href=#'+$active.attr('id')+']').addClass('link-active');
    });

    // Register each section as a waypoint.
    //$('#content-box section').waypoint({offset: '10%'});

    // Hide "go to top link"
	$('.go-up').addClass('hidden');

    // Make the navbar stick to the top of the page when we go down
    // Make the "go to top link" disappear when we go up
    // $('#content-head').sticky({topSpacing:66});
    $('#content-head').waypoint(direction => {
        //$('body').toggleClass('sticky', direction === "down");
        $('.go-up').toggleClass('hidden', direction === "up");
    });


    // Negates the flash of non-active nav.
    $('body > header nav a').click(function() {
        $(this).addClass('link-active');
    });

	// Wicked credit to
	// http://www.zachstronaut.com/posts/2009/01/18/jquery-smooth-scroll-bugs.html
	var scrollElement = 'html, body';
	$('html, body').each(function () {
		var initScrollTop = $(this).attr('scrollTop');
		$(this).attr('scrollTop', initScrollTop + 1);
		if ($(this).attr('scrollTop') === initScrollTop + 1) {
			scrollElement = this.nodeName.toLowerCase();
			$(this).attr('scrollTop', initScrollTop);
			return false;
		}
	});

    function smoothScrollToHash(target, setHash, animate) {
        // We don't want the header to activate smooth the scrolling mechanism.
        if ($('#header-content ' + target).length) {
            return;
        }

        var $target = $(target);

        var offset = $target.offset();
        if (offset) {
            offset = offset.top;
        }

        // Change URL hash without page jump, so the page scrolls via
        // jQuery's animate instead of an abrupt jump.
        // - http://lea.verou.me/2011/05/change-url-hash-without-page-jump/
        if (setHash) {
            if (window.history.pushState) {
                window.history.pushState(null, null, target);
            } else {
                window.location.hash = target;
            }
        }

        if (animate) {
            $(scrollElement).stop().animate({
                'scrollTop': offset
            }, 500, 'swing');
        } else {
            $(scrollElement).scrollTop(offset);
        }

    }

	// Smooth scrolling for internal links
	$("a[href^='#']:not([data-js='no-scroll'])").click(function(event) {
		event.preventDefault();
        var target = this.hash,
            setHash = true,
            animate = true;
        smoothScrollToHash(target, setHash, animate);
    });

    // Smooth scrolling on page load
    setTimeout(function() {
        if (window.location.hash) {
            const target = window.location.hash,
                setHash = false,
                animate = false;
            smoothScrollToHash(target, setHash, animate);
        }
    }, 1);
});
